import { render, staticRenderFns } from "./TagsCriar.vue?vue&type=template&id=4770429a"
import script from "./TagsCriar.vue?vue&type=script&lang=js"
export * from "./TagsCriar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports